import { Close } from '@mui/icons-material';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import type { ReactNode } from 'react';
import styled from 'styled-components';

const IconButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

type Props = {
  children: ReactNode;
  onClose?: () => void;
  isOpen: boolean;
};

const PluginDialog = ({ children, onClose, isOpen }: Props): ReactNode => {
  return (
    <Dialog
      open={isOpen}
      onClose={(_, reason) => {
        if (reason === 'backdropClick') {
          return;
        }

        onClose && onClose();
      }}
      fullWidth={false}
      maxWidth={'md'}
    >
      <DialogTitle sx={{ p: 0 }}>
        <IconButtonWrapper>
          <IconButton onClick={onClose} data-testid='close-button' size='large'>
            <Close />
          </IconButton>
        </IconButtonWrapper>
      </DialogTitle>
      <DialogContent sx={{ display: 'flex', p: 0, justifyContent: 'center' }}>
        <div style={{ paddingLeft: '20px', paddingRight: '20px' }}>
          {children}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PluginDialog;
